export default "__VITE_ASSET__B3cJuAWX__"